export const paymentProviderAchTypeMapping = {
  AuthorizeNetProvider: {
    checking: 'Checking',
    savings: 'Savings',
    businessChecking: 'Business Checking',
  },
  PayProsProvider: {
    checking: 'Checking',
    savings: 'Savings',
    business_checking: 'Business Checking',
    business_savings: 'Business Savings',
  },
  SagePaymentsProvider: {
    checking: 'Checking',
    savings: 'Savings',
    businessChecking: 'Business Checking',
    businessSavings: 'Business Savings',
  },
  TransactionExpressProvider: {
    personal_checking: 'Checking',
    personal_savings: 'Savings',
    business_checking: 'Business Checking',
    business_savings: 'Business Savings',
  },
  PayrixProvider: {
    checking_account: 'Checking',
    savings_account: 'Savings',
    corporate_checking_account: 'Business Checking',
    corporate_savings_account: 'Business Savings',
  },
  StopayProvider: {
    CorpChecking: 'Business Checking',
    CorpSavings: 'Business Savings',
    Checking: 'Checking',
    Savings: 'Savings',
  },
};

export default {
  paymentProviderAchTypeMapping,
};
